import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { api } from '../../services/api';

// Someone who wrote straight to Alina is still a lead - otherwise half the
// pipeline lives in her phone and the report is a lie.
export default function ManualLeadForm({ onClose, onCreated }) {
  const { t } = useTranslation('common');
  const [form, setForm] = useState({ name: '', phone: '', email: '', company: '', message: '', source_note: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const set = (field) => (event) => setForm({ ...form, [field]: event.target.value });

  const submit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      await api.createCrmLead({
        name: form.name.trim(),
        phone: form.phone.trim() || null,
        email: form.email.trim() || null,
        company: form.company.trim(),
        message: form.message.trim(),
        source_note: form.source_note.trim(),
      });
      await onCreated();
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setError(detail?.problem ? t(`crm.phoneProblem.${detail.problem}`) : String(detail || e.message));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="crm-card crm-manual" onSubmit={submit}>
      <div className="crm-card-head">
        <h2>{t('crm.manual.title')}</h2>
        <button type="button" className="crm-icon-btn" onClick={onClose} aria-label={t('crm.close')}>
          <X size={16} />
        </button>
      </div>
      <div className="crm-field-grid">
        <label className="crm-field">
          {t('crm.manual.name')}
          <input className="crm-input" value={form.name} onChange={set('name')} required maxLength={120} />
        </label>
        <label className="crm-field">
          {t('crm.manual.phone')}
          <input className="crm-input" value={form.phone} onChange={set('phone')} placeholder="+380 67 123 45 67" maxLength={25} />
        </label>
        <label className="crm-field">
          {t('crm.manual.email')}
          <input className="crm-input" type="email" value={form.email} onChange={set('email')} maxLength={200} />
        </label>
        <label className="crm-field">
          {t('crm.manual.company')}
          <input className="crm-input" value={form.company} onChange={set('company')} maxLength={200} />
        </label>
        <label className="crm-field">
          {t('crm.manual.sourceNote')}
          <input className="crm-input" value={form.source_note} onChange={set('source_note')} placeholder={t('crm.manual.sourceHint')} maxLength={200} />
        </label>
      </div>
      <label className="crm-field">
        {t('crm.manual.message')}
        <textarea className="crm-input" rows={2} value={form.message} onChange={set('message')} maxLength={2000} />
      </label>
      {error && <div className="crm-error">{error}</div>}
      <div className="crm-card-actions">
        <button type="submit" className="crm-btn primary" disabled={saving || !form.name.trim()}>
          {t('crm.manual.save')}
        </button>
      </div>
    </form>
  );
}
